export const getProductCategory = (product) => {
  if (product.viewingPeriodHours) {
    return 'rental'
  }

  return 'subscription'
}
